<template>
  <div>
    <form
      v-if="!message"
      @submit.prevent="register">
      <h1>{{ $t('register/welcome-message') }}</h1>
      <p v-html="$t('register/welcome-submessage')" />
      <FormInput
        v-model="name"
        :validation="v$.name"
        autocomplete="given-name"
        class="h-margin-top-xl"
        :label="$t('account/full-name')" />
      <FormInput
        v-model="email"
        required
        :validation="v$.email"
        autocomplete="email"
        type="email"
        class="h-margin-top"
        :label="$t('general/emailaddress')" />
      <FormPassword
        v-model="password"
        :validation="v$.password"
        autocomplete="new-password"
        class="h-margin-top"
        :label="$t('auth/password')" />
      <FormPassword
        v-model="passwordRepeat"
        :validation="v$.passwordRepeat"
        autocomplete="new-password"
        class="h-margin-top"
        :label="$t('auth/repeat-password')" />

      <LazyNotificationGroup
        v-if="errors"
        class="h-margin-top-s">
        <LazyNotification
          v-for="(error, key) in errors"
          :key="key"
          v-html="error.message" />
      </LazyNotificationGroup>

      <Btn
        color="cta"
        shape="pill"
        full-width="all"
        class="h-margin-top">
        {{ $t('account/register') }}
      </Btn>
      <Btn
        color="link"
        full-width="all"
        shape="pill"
        :to="{ name: $lang + '-login' }">
        {{ $t('register/already-customer') }}
      </Btn>
    </form>
    <div v-else>
      <h1 class="h-margin-bottom-l h-margin-top-xl">
        {{ $t('register/welcome-message') }}
      </h1>
      <p>
        {{ $t('register/email-sent') }}
      </p>
    </div>
  </div>
</template>
<script setup>
import { useVuelidate } from '@vuelidate/core'
import { email as emailValidator, required, minLength, sameAs } from '@vuelidate/validators'

const authStore = useAuthStore()
const name = ref(null)
const email = ref(null)
const password = ref(null)
const passwordRepeat = ref(null)
const message = ref(null)
const errors = ref(null)

const rules = {
  name: {
    required
  },
  email: {
    required,
    emailValidator
  },
  password: {
    required,
    minLength: minLength(8)
  },
  passwordRepeat: {
    required,
    sameAsPassword: sameAs(password)
  }
}
const v$ = useVuelidate(rules, { name, email, password, passwordRepeat })

const register = async () => {
  v$.value.$validate()
  if (v$.value.$invalid) { return }
  try {
    const data = await authStore.register({
      name: name.value,
      email: email.value,
      password: password.value,
      passwordRepeat: passwordRepeat.value
    })
    if (data) {
      message.value = data
      window.scrollTo({ top: 0 })
    }
  } catch (e) {
    if (e.response._data?.errors) {
      errors.value = e.response._data?.errors
    }
  }
}
</script>
